var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"details payment-term-details charge-date"},[_vm._v("\n    "+_vm._s(_vm.$t('paymentTerms.canceled'))+"\n  ")]),_vm._v(" "),_c('Refunds',{attrs:{"paymenttermid":_vm.paymentTerm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }